/**
 * The name of the bundled sound file which will be played when a
 * participant enters lobby.
 */
export const KNOCKING_PARTICIPANT_FILE = 'knock.mp3';
/**
 * The name of the bundled sound file which will be played when a
 * participant is admitted from lobby.
 */
export const LOBBY_APPROVED_FILE = 'joined.mp3';
